import { render, staticRenderFns } from "./CustomizationTable.vue?vue&type=template&id=437e530a&scoped=true&"
import script from "./CustomizationTable.vue?vue&type=script&lang=js&"
export * from "./CustomizationTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomizationTable.vue?vue&type=style&index=0&id=437e530a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437e530a",
  null
  
)

export default component.exports